/* eslint-disable no-use-before-define */
import React, { useContext, useRef } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled, { css } from 'styled-components';
import { useLocalization } from 'gatsby-theme-i18n';

import useOutsideClick from 'hooks/useOutsideClick';
import ModalContext from 'contexts/ModalContext';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.35);
  z-index: 999;
  transition: 0.3s;
  opacity: 0;
  visibility: hidden;
  ${({ isVisible }) =>
    isVisible &&
    css`
      opacity: 1;
      visibility: visible;
      & > ${Wrapper} {
        opacity: 1;
        visibility: visible;
        transform: translate(-50%, -50%);
      }
    `}
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1300px;
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: ${({ theme }) => theme.colors.white};
  transition: 0.3s;
  opacity: 0;
  visibility: hidden;
  transform: translate(-50%, -40%);
  z-index: 20;
  overflow: auto;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  ${({ theme }) => theme.mq.lg} {
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
      background-color: ${({ theme }) => theme.colors.gray};
    }
  }
  ${({ theme }) => theme.mq.xxl} {
    height: 85%;
  }
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.dark};
  padding: 60px 20px 40px;
  ${({ theme }) => theme.mq.md} {
    padding: 100px;
  }
`;

const Content = styled.div`
  b,
  strong {
    font-weight: 500;
    font-size: 1.1em;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0.5rem 0 1.5rem;

    li {
      padding-left: 1.4em;
      text-indent: -1.2em;
      margin: 0 0 0.25rem;

      &::before {
        content: '';

        display: inline-block;
        width: 7px;
        height: 7px;

        margin-right: 12px;

        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.colors.dark};
        background: ${({ theme }) => theme.colors.dark};
      }
      li::before {
        background: transparent;
      }
    }
  }

  p,
  li {
    line-height: ${({ line }) => line || '1.7'};
    font-weight: 400;

    font-size: 1.4rem;
    text-align: left;

    color: ${({ theme }) => theme.colors.text};
    ${({ theme }) => theme.mq.md} {
      font-size: 1.5rem;
    }
  }

  p {
    display: block;
    margin-bottom: 1.5rem;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    display: block;

    font-weight: 600;
    text-align: left;
    color: ${({ theme }) => theme.colors.dark};

    margin: 1rem 0 1.5rem;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  border: none;
  transition: 0.3s;
  background: ${({ theme }) => theme.colors.white300};
  padding: 12px;
  @media (max-width: 360px) {
    right: 15px;
  }
  svg {
    width: 100%;
    height: 100%;
    transition: 0.3s;
  }
  &:hover {
    background: ${({ theme }) => theme.colors.primary};
    svg {
      fill: #fff;
    }
  }
`;

const Modal = () => {
  // const { visible, closeModal } = useContext(ModalContext);
  // const modalRef = useRef(null);
  // useOutsideClick(modalRef, closeModal);

  // const { locale } = useLocalization();

  // const query = useStaticQuery(
  //   graphql`
  //     query PrivacyPolicy {
  //       pl: wpPage(slug: { eq: "polityka-prywatnosci" }) {
  //         title
  //         content
  //       }
  //       de: wpPage(slug: { eq: "datenschutzerklaerung" }) {
  //         title
  //         content
  //       }
  //     }
  //   `
  // );

  return <div></div>;
};

export default Modal;
